import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { AlertType } from '../../../core/model';

@Component({
  selector: 'py-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NotificationComponent {
  @Input() type: AlertType = AlertType.Info;
  @Input() message?: string;
  @Input() icon = true;
  @Input() themeType: string = 'fill';
  @Input() customIcon?: string;

  @HostBinding('class.bordered')
  @Input()
  showBorder = true;

  @HostBinding('class.tiny')
  @Input()
  tiny = false;

  @HostBinding('class.slim')
  @Input()
  slim = false;

  get hasMessage(): boolean {
    return !!this.message;
  }

  @HostBinding('class.danger')
  get applyDangerClass(): boolean {
    return this.type === AlertType.Danger;
  }

  @HostBinding('class.warning')
  get applyWarningClass(): boolean {
    return this.type === AlertType.Warning;
  }

  @HostBinding('class.info')
  get applyInfoClass(): boolean {
    return this.type === AlertType.Info;
  }

  @HostBinding('class.success')
  get applySuccessClass(): boolean {
    return this.type === AlertType.Success;
  }

  @HostBinding('class.notification')
  get applyNotificationClass(): boolean {
    return this.type === AlertType.Notification;
  }

  get iconType(): string {
    if (this.customIcon) {
      return this.mapToIconType(this.customIcon);
    }

    switch (this.type) {
      case AlertType.Info:
      case AlertType.Notification:
        return this.mapToIconType('info-circle');
      case AlertType.Danger:
        return this.mapToIconType('warning');
      case AlertType.Warning:
        return this.mapToIconType('exclamation-circle');
      case AlertType.Success:
        return this.mapToIconType('check-circle');
      default:
        return this.mapToIconType('warning');
    }
  }

  private mapToIconType(iconType: string): string {
    // Use our own WCAG contrast-appropriate icons instead of the filled icons
    if (this.themeType === 'fill') {
      switch (iconType) {
        case 'info-circle':
          return 'py-info-circle';
        case 'check-circle':
          return 'py-check-circle';
        case 'warning':
          return 'py-danger';
        case 'exclamation-circle':
          return 'py-warning';
      }
    }
    return iconType;
  }
}
